import React from "react";
import {
  Alert,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
  Table,
} from "reactstrap";
import { fmtInvoiceRupee } from "../pages/storeSalesDashboardHelpers";

export const SHIPMENT_INVOICE_LINE_DESCRIPTION = "Modular Cabinet Panels";
export const SHIPMENT_INVOICE_LINE_HSN = "94034000";

const StoreShipmentInvoiceModal = ({
  isOpen,
  toggle,
  shipmentLabel,
  loading,
  error,
  invoice,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Invoice</ModalHeader>
      <ModalBody>
        <div className="text-muted small mb-2">{shipmentLabel}</div>
        {loading && (
          <div className="py-4 text-center">
            <Spinner />
          </div>
        )}
        {error && (
          <Alert color="danger" className="mb-0" fade={false}>
            {error}
          </Alert>
        )}
        {!loading && invoice && (
          <>
            <Table bordered responsive size="sm" className="mb-3">
              <thead className="table-light">
                <tr>
                  <th style={{ width: "2.5rem" }}>#</th>
                  <th>Item &amp; Description</th>
                  <th>HSN /SAC</th>
                  <th className="text-end">Qty</th>
                  <th className="text-end">Rate</th>
                  <th className="text-end">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>{SHIPMENT_INVOICE_LINE_DESCRIPTION}</td>
                  <td>{SHIPMENT_INVOICE_LINE_HSN}</td>
                  <td className="text-end">{`${invoice.quantity} Nos`}</td>
                  <td className="text-end">
                    {fmtInvoiceRupee(invoice.average_price)}
                  </td>
                  <td className="text-end">
                    {fmtInvoiceRupee(invoice.items_price)}
                  </td>
                </tr>
              </tbody>
            </Table>
            <div className="d-flex justify-content-end">
              <div
                className="d-flex flex-column gap-2 small"
                style={{ minWidth: "18rem" }}
              >
                {(() => {
                  const discPct = invoice.discount?.percentage;

                  return (
                    <>
                      {discPct ? (
                        <div className="d-flex justify-content-between gap-3">
                          <span>
                            Discount
                            {` (${discPct}%)`}
                          </span>
                          <span className="text-end text-nowrap">
                            {fmtInvoiceRupee(invoice.discount.price)}
                          </span>
                        </div>
                      ) : null}
                      <div className="d-flex justify-content-between gap-3">
                        <span>Total Taxable Amount</span>
                        <span className="text-end text-nowrap">
                          {fmtInvoiceRupee(invoice.taxable_price)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between gap-3">
                        <span>{`Tax (${invoice.tax.percentage}%)`}</span>
                        <span className="text-end text-nowrap">
                          {fmtInvoiceRupee(invoice.tax.price)}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between gap-3 fw-bold fs-6">
                        <span>Total</span>
                        <span className="text-end text-nowrap">
                          {fmtInvoiceRupee(invoice.total)}
                        </span>
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default StoreShipmentInvoiceModal;
